import React from "react";

const LoadingIcon = () => {
  return (
    <span className=" w-7 h-7 border-4 border-[#CECECE] border-l-[var(--MColor)] rounded-full shrink-0 animate-spin shrink-0" />
  );
};

export default LoadingIcon;
